/**
 * Category ke SEO URL — `/c/tmt-bar` (rulebook §4). Purana `/items/<id>/category/<name>`
 * bhi chalta rahega; naye links sab yahin se banao.
 * Slug = naam lowercase, sirf a-z 0-9, baaki sab '-' — backend sitemap bhi yahi rule use karta hai
 * (lhw-backend-main/src/projects/global/sitemap/sitemap.service.ts), dono ek jaise rakhna.
 */
export const slugify = (name: string): string =>
  String(name || "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const categoryPath = (c: { id?: string; _id?: string; name: string }): string => {
  const slug = slugify(c.name);
  return slug ? `/c/${slug}` : `/items/${c.id || c._id || ""}/category/${encodeURIComponent(c.name || "")}`;
};
